import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'

import * as R from 'ramda'

import {List, ListItem} from 'material-ui/List'
import MenuItem from 'material-ui/MenuItem'
import Divider from 'material-ui/Divider'

import { dirtyRead, doc } from 'selectors/common'

let select = dirtyRead(
	(state, props) => ({
		tenant: doc(state, props.objectID)
	})
)

export class TenantCard extends Component {
	render(){
		let { props } = this
		return(
			(!props.tenant)?
				<div></div>
				:
				<ListItem
					style={{
						overflow: 'hidden'
					  , paddingLeft: "0"
					  , marginLeft: "0"
					  , margin: "0"
					  , textOverflow: "ellipsis"
					  , fontSize: "16px"
					}}
					innerDivStyle={{
						padding: "0 15px"
					}}
					className="list-hover"
				>
					<Link
						className="tenant-card"
						to={`/manager/tenants/${props.tenant._id}`}
						style={{
							textDecoration: 'none'
						  , position: "relative"
						  , zIndex: "1000"
						  , display: "inline-block"
						  , justifyContent: "space-between"
						  , width: "80%"
						  , padding: "15px 0"
						  , paddingLeft: "0px"
						  , color: "black"
						}}
						key={props.tenant._id}
					>
						<p
							style={{
								margin:"0"
							  , paddingTop: "5px"
							  , fontWeight: props.bold && "bold"
							}}
						>
							{(props.tenant.tenant)? props.tenant.tenant: props.tenant.firstName + " " + props.tenant.lastName}
						</p>
					</Link>
				</ListItem>
		)
	}
}
export default connect(select)(TenantCard)



// WEBPACK FOOTER //
// ./src/routes/manager/tenantForm/TenantCard.js